function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip02)"
}, React.createElement("mask", {
  id: "mask02",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: -8,
  y: -79,
  width: 120,
  height: 1038
}, React.createElement("path", {
  className: "line-mask",
  d: "M112 -79H-8V959H112V-79Z",
  fill: "url(#paint02_linear)"
})), React.createElement("g", {
  mask: "url(#mask02)"
}, React.createElement("path", {
  className: "dashed-line",
  opacity: 0.323863,
  d: "M52.9999 -184C18.9937 -134.611 2.1604 -83.944 2.49991 -32C2.83941 19.944 20.3394 71.2773 54.9999 122C87.3332 174.702 103.5 227.036 103.5 279C103.5 330.964 87.3332 382.631 54.9999 434C19.9999 488.093 2.49991 541.093 2.49991 593C2.49991 644.907 19.9999 695.907 54.9999 746C87.3332 798.444 103.5 851.777 103.5 906C103.5 960.223 87.3332 1015.22 54.9999 1071",
  stroke: "url(#paint1_radial)",
  strokeWidth: 4,
  strokeDasharray: "14 14"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("radialGradient", {
  id: "paint1_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(53.0012 443) rotate(-90) scale(457.5 70630.6)"
}, React.createElement("stop", {
  offset: 0.744627,
  stopColor: "#00C1F1"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#00C1F1",
  stopOpacity: 0
})), React.createElement("linearGradient", {
  id: "paint02_linear",
  x1: 52,
  y1: 888.5,
  x2: 52,
  y2: 959,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "white"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), React.createElement("clipPath", {
  id: "clip02"
}, React.createElement("rect", {
  width: 106,
  height: 903,
  fill: "white"
})));

var SvgStepsLine = function SvgStepsLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 106,
    height: 903,
    viewBox: "0 0 106 903",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStepsLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/steps-line.18b1d95e.svg";
export { ForwardRef as ReactComponent };